import React from 'react'
import Draggable from "../../../DnD/Draggable";
import InputWrapper from "../../../../../components/Input/InputWrapper";

function LongText() {
    return (
        <Draggable id="input-long">
            <InputWrapper>
                Long text
                <div className="text"/>
            </InputWrapper>
        </Draggable>
    )
}

export default LongText
